import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface StatItem {
  value: number;
  suffix: string;
  label: string;
  description: string;
}
function CountUp({
  target,
  suffix
}: {
  target: number;
  suffix: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true
  });
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 1800;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 16);
    return () => clearInterval(timer);
  }, [inView, target]);
  return <span ref={ref} data-id="element-375">
      {count}
      {suffix}
    </span>;
}
export function Stats() {
  const stats: StatItem[] = [{
    value: 1991,
    suffix: '',
    label: 'Рік заснування',
    description: 'Понад 30 років розвитку'
  }, {
    value: 500,
    suffix: '+',
    label: 'Членів федерації',
    description: 'По всій Україні'
  }, {
    value: 50,
    suffix: '+',
    label: 'Змагань на рік',
    description: 'Національні та міжнародні'
  }, {
    value: 25,
    suffix: '+',
    label: 'Регіонів України',
    description: 'Охоплення по країні'
  }];
  return <section className="bg-primary py-12 border-t border-white/5 border-b border-white/5" data-id="element-376">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-377">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-378">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`text-center ${index < stats.length - 1 ? 'lg:border-r lg:border-white/5' : ''}`} data-id="element-379">
              <div className="text-3xl md:text-4xl font-heading font-bold text-white mb-1" data-id="element-380">
                <CountUp target={stat.value} suffix={stat.suffix} data-id="element-381" />
              </div>
              <div className="text-white/80 font-medium text-sm md:text-base mb-1" data-id="element-382">
                {stat.label}
              </div>
              <div className="text-white/40 text-xs" data-id="element-383">{stat.description}</div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}